import { ScrollCollectSettingsResponse } from '../services/types/api';

// Fallback constants (used when settings are not available)
export const DEFAULT_NUMBER_OF_PRIZES = 5;
export const DEFAULT_DISCOUNT_AMOUNT = 10;
export const DEFAULT_PRIZE_AMOUNT = 2;
export const MAX_PRODUCTS_FOR_GAME = 900;

// Helper functions to get values from settings with fallbacks
export const getNumberOfPrizes = (settings?: ScrollCollectSettingsResponse | null): number => {
  return settings?.collectableCount ?? DEFAULT_NUMBER_OF_PRIZES;
};

export const getDiscountAmount = (settings?: ScrollCollectSettingsResponse | null): number => {
  if (!settings?.discount) return DEFAULT_DISCOUNT_AMOUNT;

  // Convert cents to euros (assuming value is in cents)
  return settings.discount.value / 100;
};

export const getPrizeAmount = (settings?: ScrollCollectSettingsResponse | null): number => {
  if (!settings?.discount || !settings?.collectableCount) return DEFAULT_PRIZE_AMOUNT;

  // Calculate prize amount as total discount / number of collectables
  // Convert from cents to euros
  return settings.discount.value / settings.collectableCount / 100;
};

// Deprecated constants - use helper functions instead
/** @deprecated Use getNumberOfPrizes(settings) instead */
export const NUMBER_OF_PRIZES = DEFAULT_NUMBER_OF_PRIZES;
/** @deprecated Use getDiscountAmount(settings) instead */
export const DISCOUNT_AMOUNT = DEFAULT_DISCOUNT_AMOUNT;
/** @deprecated Use getPrizeAmount(settings) instead */
export const PRIZE_AMOUNT = DEFAULT_PRIZE_AMOUNT;
